module.exports = __webpack_public_path__ + "source-sans-pro-v13-latin-regular.woff2?899c8f78ce650d4009d42443897aa723";